import React, { useState } from "react";
import TopLoader from "../components/Loader/TopLoader";
import { useTranslation } from "react-i18next";
import { Button, ButtonGroup, Table } from "react-bootstrap";

const FoodMenu = () => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const weeks = ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5"];
    const currentMonth = new Date().getMonth();
    const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    const [selectedMonth, setSelectedMonth] = useState(currentMonth);
    const [selectedWeek, setSelectedWeek] = useState(0);

    const handleMonthClick = (index) => {
        setSelectedMonth(index);
    };

    const handleWeekClick = (index) => {
        setSelectedWeek(index);
    };

    return (
        <div>
            <TopLoader loading={isLoading ? "50" : "100"} />
            <div className="row col-12 d-flex justify-content-center mt-5 bg-white">
                {/* <div className="construction"></div> */}
            </div>
            <div className="px-0 px-md-3">
                <div className="col-12 d-flex justify-content-between align-items-center">
                    <div>
                        <h5 className="text-center">{t("Food Menu")}</h5>
                    </div>
                </div>

                <div className="row justify-content-center my-3">
                    <ButtonGroup>
                        {months.map((month, index) => (
                            <Button
                                key={index}
                                variant={index === selectedMonth ? "primary" : "light"}
                                onClick={() => handleMonthClick(index)}
                            >
                                {month}
                            </Button>
                        ))}
                    </ButtonGroup>
                </div>
                <div className="row justify-content-center">
                    <ButtonGroup>
                        {weeks.map((week, index) => (
                            <Button key={index}
                                variant={index === selectedWeek ? "primary" : "light"}
                                onClick={() => handleWeekClick(index)}
                            >
                                {week}
                            </Button>
                        ))}
                    </ButtonGroup>
                </div>

                <h5 className="text-center mt-5">Weekly Menu</h5>
                <Table bordered className="mt-5">
                    <thead>
                        <tr>
                            <th>Days</th>
                            <th>Breakfast</th>
                            <th>Lunch</th>
                            <th>Dinner</th>
                        </tr>
                    </thead>
                    <tbody>
                        {days.map((day, index) => (
                            <tr key={index}>
                                <td>{day}</td>
                                <td><input type="text" className="form-control" placeholder="Enter" /></td>
                                <td><input type="text" className="form-control" placeholder="Enter" /></td>
                                <td><input type="text" className="form-control" placeholder="Enter" /></td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                <div className="d-flex justify-content-end mt-3">
                    <button type="reset" className="btn btn-secondary me-2 col-md-1">
                        {t("Reset")}
                    </button>
                    <button type="submit" className="btn btn-primary me-2 col-md-1">
                        {t("Submit")}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default FoodMenu